<template>
    <v-container class="pt-0 pb-5">
        <v-row>
            <v-col>
                <div class="pa-2 rounded elevation-1 bg-white">
                    <h5><v-icon icon="mdi-alert" class="mr-1" color="primary"></v-icon> Nous sommes désolé</h5>
                    <p>Une erreur est survenue lors de la validation de votre commande</p>
                    <div>
                        <ul>
                            <li v-for="error in booking_availability.errors" :key="error">{{ error }}</li>
                        </ul>
                    </div>

                    <div class="d-flex justify-center">
                        <router-link class="sm-fullwidth" :to="{ name: 'Inscriptions' }">
                            <v-btn color="primary-dark" block class="sm-fullwidth mt-2" variant="default" size="small">
                                <v-icon icon="mdi-arrow-left-bold" class="mr-1"></v-icon> Retourner à l'étape précedente
                            </v-btn>
                        </router-link>
                    </div>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    props: ['booking_availability'],
    name: 'BookingAvailabilityAlert',
    data() {
        return {
            // Add your component data here
        };
    },
    methods: {
        // Add your component methods here
    },
};
</script>

<style scoped>
/* Add your component styles here */
</style>